import { type ComponentProps } from "react";

export const GolfCourse = (props: ComponentProps<"svg">) => (
  <svg
    width={props.width ?? "1.875rem"}
    height={props.height ?? "1.875rem"}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.5 31.5C29.7426 31.5 30.75 30.4926 30.75 29.25C30.75 28.0074 29.7426 27 28.5 27C27.2574 27 26.25 28.0074 26.25 29.25C26.25 30.4926 27.2574 31.5 28.5 31.5Z"
      fill={props.fill ? props.fill : "#41942A"}
    />
    <path
      d="M24.75 8.88L12.75 3V30H9.75V27.405C7.065 27.93 5.25 28.89 5.25 30C5.25 31.65 9.285 33 14.25 33C19.215 33 23.25 31.65 23.25 30C23.25 28.515 20.01 27.285 15.75 27.045V13.47L24.75 8.88Z"
      fill={props.fill ? props.fill : "#41942A"}
    />
  </svg>
);
